import React, {Fragment} from 'react';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import {componentList} from '@/api/global';
import {useContentDBSearch, useListingsSolrSearch, useListingsSolrMLTSearch} from '@/utils/hooks';
import {useState} from "react";
import Spinner from '@/components/01_atoms/Spinner';
import {chooseRandomList} from '@/api/global';
import {useRouter} from 'next/router';

function ContentList(props) {
  const router = useRouter()
  let { comp, compProps, fetchOpts, pageCurr, perPage, noPager, random, noresult,
    spacing, justifyContent, colXs, colS, colMd, colLg, colXlg, solr_q, solr_index} = props;

  if (props.block) {
    ({ comp, compProps, fetchOpts, pageCurr, perPage, noPager, random, noresult,
      spacing, justifyContent, colXs, colS, colMd, colLg, colXlg, solr_q, solr_index} = props.block);
  }

  if (!fetchOpts || !comp) {
    return null;
  }

  perPage = perPage || 0;
  spacing = spacing || 1;
  const DynamicComponent = componentList[comp];
  const [currPage, setCurrPage] = useState({
    curr: router?.query?.pager || (pageCurr === 0 && '0') || ((typeof pageCurr === 'undefined' || pageCurr === null) && '0') || (pageCurr === -1 && '0') || pageCurr || 1,
    off: ((pageCurr && pageCurr > 1) ? (pageCurr * perPage) : 0)
  });
  let data, isLoading, isError, error, random_arr;

  //Math.round(12 / cols)
  colXs = colXs || 12;

  const handlePageClick = (event, val) => {
    let offset = 0, new_page = val;
    // console.log('setPageCount 0: ', fetchOpts, val, offset, router, window.location)
    // Drupal JSONAPI has offset:   page[limit]=10&page[offset]=0
    // Drupal Views first page starts with 0. &offset=3 is optional:   page=0&items_per_page=10
    // Solr has offset:   &rows=10&start=0
    if (!fetchOpts?.opts?.dbview) {
      offset = val == 1 ? 0 : (val - 1) * perPage;
      new_page = val == 1 ? 0 : (val - 1);
    }
    else {
      val = val - 1;
      new_page = val;
    }
    // console.log('setPageCount 1: ', val, new_page, offset)
    if (!router.asPath?.includes('pager=')) {
      if (router.asPath?.includes('?')) {
        router.replace(window.location.href + '&pager=' + val, undefined, {shallow: true});
      }
      else {
        router.replace(window.location.href + '?pager=' + val, undefined, {shallow: true});
      }
    }
    else {
      router.replace(window.location.href.replace(/pager=\d+/,'pager=' + val), undefined, {shallow: true});
    }
    setCurrPage({curr: new_page, off: offset});
  };

  if (fetchOpts['pager']) {
    delete fetchOpts['pager'];
  }


  // @todo:
  // https://stackoverflow.com/questions/32138513/how-to-destructure-an-object-to-an-already-defined-variable
  if (fetchOpts.solrListings) {
    ({
      data,
      isLoading,
      isError
    } = useListingsSolrSearch(fetchOpts, perPage, currPage.off, solr_q, solr_index));
  }
  else if (fetchOpts.solrMltListings) {
    ({
      data,
      isLoading,
      isError
    } = useListingsSolrMLTSearch(fetchOpts, perPage, currPage.off, solr_q, solr_index));
  }
  else {
    let sett = {
      ...fetchOpts,
      pageLimit: perPage,
      pageOffset: currPage.off
    };

    if (fetchOpts?.opts?.dbview == 'json') {
      {/* Pagination starts from 1, not 0 */}
      if (pageCurr !== -1) {
        sett.pageOffset = currPage.curr;
      }
      else if (pageCurr === -1 && currPage.curr !== '0') {
        setCurrPage({curr: '0', off: 0});
      }
    }

    ({data, isLoading, isError} = useContentDBSearch(sett));
  }

  if (data?.listings && !data?.page_data) {
    data.page_data = data.listings;
  }

  if (data?.page_data?.length < 1 && !isLoading && !isError && !noresult) {
    return null;
  }
  if (isError) {
    console.warn("Content retrieve error: ", isError);
  }

  return (
      <>
        {isError && !isLoading &&
        <p>Network issue prevented the data from loading..</p>
        }
        {!isError && !data && isLoading &&
        <Spinner/>
        }
        {data?.page_data?.length > 0 && !isLoading && !isError &&
        <Grid container spacing={spacing} justifyContent='center'>
          <>
            {data?.page_data !== undefined && Array.isArray(data?.page_data) && !isNaN(random) &&
            chooseRandomList(data.page_data, random).map((node) => {
              return (<Fragment key={`rand-${node?.internalId}`}>
                {data.page_data?.length >= 1 && perPage == 1 &&
                <Grid item xs={12} key={node.id}>
                  <DynamicComponent key={`card-list-${node.internalId}`}
                                    node={node} {...compProps} />
                </Grid>
                }
                {data.page_data?.length >= 1 && perPage != 1 &&
                <Grid item xs={colXs} sm={colS} md={colMd} lg={colLg}
                      xl={colXlg} key={node.id}>
                  <DynamicComponent key={`card-list-${node.internalId}`}
                                    node={node} {...compProps} />
                </Grid>
                }
              </Fragment>)
            })
            }
            {data?.page_data !== undefined && Array.isArray(data?.page_data) && isNaN(random) &&
            <>
              {data.page_data?.length >= 1 && perPage == 1 &&
              <Grid item xs={12} key={data.page_data[0].id}>
                <DynamicComponent
                    key={`card-list-${data.page_data[0].internalId}`}
                    node={data.page_data[0]} {...compProps} />
              </Grid>
              }
              {data.page_data?.length >= 1 && perPage != 1 && data.page_data.map((node) => {
                return (
                    <Grid item xs={colXs} sm={colS} md={colMd} lg={colLg}
                          xl={colXlg} key={node.id}>
                      <DynamicComponent key={`card-list-${node.internalId}`}
                                        node={node} {...compProps} />
                    </Grid>
                );
              })
              }
            </>
            }
          </>
          {!noPager && data && data.ttlPages && parseInt(data.ttlPages) > 1 &&
          <Grid item xs={12}>
            <Box mt={4} align="center">
              {/* <Pagination> pagination starts from 1, not 0 */}
              <Pagination count={parseInt(data.ttlPages) || 10}
                          page={(pageCurr === -1) ? 0 : parseInt(currPage.curr) + 1}
                          size="small" siblingCount={2} color="primary"
                          variant="outlined" shape="rounded"
                          onChange={(ev, val) => handlePageClick(ev, val)}/>
            </Box>
          </Grid>
          }
        </Grid>
        }
        {!data?.page_data?.length && !isLoading && !isError && noresult}
      </>
  )
}

export default ContentList;
